import {
    optionsAdministrative,
    optionsFinancial,
    optionsTechnical,
    optionsVolksTotalPortal,
    supportStatusOptions,
    supportSubjectOptions,
    SupportType,
} from "./constants";

interface SubjectOption {
    id: string;
    label: string;
}

export const getSupportSubjectOptions = (
    supportType?: string,
    allOption?: SubjectOption,
) => {
    const options = supportType === "TECHNICAL_SUPPORT"
        ? supportSubjectOptions
        : supportStatusOptions;

    return allOption ? [...options, allOption] : options;
};

export const getSupportThemeOptions = (subject?: string) => {
    if (subject === SupportType.ADMINISTRATIVE) {
        return optionsAdministrative;
    }

    if (subject === SupportType.FINANCIAL) {
        return optionsFinancial;
    }

    if (subject === SupportType.PORTAL) {
        return optionsVolksTotalPortal;
    }

    if (subject === SupportType.TECHNICAL) {
        return optionsTechnical;
    }

    return [];
};
